// import axios, { AxiosInstance } from "axios";

// const api: AxiosInstance = axios.create({
//   baseURL: "https://aitools.kapinsights.com/api/",
// });

// api.interceptors.request.use((config: any) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// export default api;

import axios, { AxiosInstance } from "axios";

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_TYPE_API_URL,
});

const refreshToken = async () => {
  try {
    const refresh_token = localStorage.getItem("refreshToken");

    if (!refresh_token) {
      throw new Error("No refresh token available");
    }
    const response = await axios.post(
      `${process.env.REACT_APP_TYPE_API_URL}Users/token/refresh?refresh_token=${refresh_token}`,
      null,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );
    const { access_token } = response.data;
    localStorage.setItem("token", access_token);
    return access_token;
  } catch (error) {
    console.error("Error refreshing token:", error);
    throw error;
  }
};

api.interceptors.request.use(
  async (config: any) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Send current language to backend
    const lang = localStorage.getItem("i18nextLng") || "en";
    config.headers["Accept-Language"] = lang;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        const access_token = await refreshToken();
        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return axios(originalRequest);
      } catch (error) {
        console.error("Error refreshing token:", error);
        throw error;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
